/** Estudios adjuntos del expediente. Persistencia en servidor (expediente-svc). */

import { ExpedienteAdjuntos, type AdjuntoExpedienteDto } from './api';

export type AdjuntoExpediente = AdjuntoExpedienteDto & { id: string };

function asList(items: AdjuntoExpedienteDto[]): AdjuntoExpediente[] {
  return items
    .filter((a): a is AdjuntoExpediente => !!a.id)
    .sort((a, b) => `${b.fecha ?? ''}${b.registradaEn ?? ''}`.localeCompare(`${a.fecha ?? ''}${a.registradaEn ?? ''}`));
}

export async function listAdjuntos(pacienteId: string): Promise<AdjuntoExpediente[]> {
  return asList(await ExpedienteAdjuntos.list(pacienteId));
}

export async function addAdjunto(input: Omit<AdjuntoExpedienteDto, 'id' | 'registradaEn'>): Promise<AdjuntoExpediente> {
  const created = await ExpedienteAdjuntos.crear({
    ...input,
    fecha: input.fecha || new Date().toISOString().slice(0, 10),
  });
  if (!created.id) throw new Error('No se pudo guardar el adjunto.');
  return created as AdjuntoExpediente;
}

export async function removeAdjunto(id: string): Promise<void> {
  await ExpedienteAdjuntos.eliminar(id);
}
